import script from "./AgeVerificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AgeVerificationModal.vue?vue&type=script&setup=true&lang=js"

import "./AgeVerificationModal.vue?vue&type=style&index=0&id=5dc764d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc764d6"]])

export default __exports__